import { makeObservable, observable} from "mobx";
import ApiResponseHandler from "@eryxcoop/appyx-comm/src/errors/ApiResponseHandler";
import MoneyRenderer from "../../utils/MoneyRenderer";
import defaultImage from "../../../media/background_images/default-image-sapore.jpg";
import errorToast from "../../../components/toast/ErrorToast";
import {ORDERS_HISTORY_PATH} from "../../../routes";

export class OrderDetailFeature {
    constructor(application, navigator, orderId) {
        this._application = application;
        this._navigator = navigator;
        this._order = null;
        this._orderId = orderId;
        this._orderPrices = null;
        this._loaded = false;
        this._loadingOrdersPage = false;
        this._orderToRepeat = null;

        makeObservable(this, {
            _loaded: observable,
            _loadingOrdersPage: observable,
            _orderToRepeat: observable
        })
    }

    async load() {
        await this._getOrder()
        if (this._order === null) {
            return
        }
        await this._getOrderPrices()
        this.finishLoading()
    }

    finishLoading() {
        this._loaded = true
    }

    get orderToRepeat() {
        return this._orderToRepeat;
    }

    set orderToRepeat(value) {
        this._orderToRepeat = value;
    }

    get loadingOrdersPage() {
        return this._loadingOrdersPage;
    }

    set loadingOrdersPage(value) {
        this._loadingOrdersPage = value;
    }

    get loaded() {
        return this._loaded;
    }

    set loaded(value) {
        this._loaded = value;
    }

    order(){
        return this._order
    }

    deliverySiteName(){
        return this._order.deliverySite.deliverySiteName
    }

    orderIsInvoiced() {
        return this._order.state === 'FACTURADO'
    }

    productImage(article) {
        const url = article.file;
        if (url.includes('invalid_url')){
            return defaultImage;
        }
        return url;
    }

    unitPriceOf(article) {
        if (this.orderIsInvoiced()) {
            const pricedArticle = this._order.articles.find(pricedArticle => pricedArticle.code.trim() === article.code.trim());
            return pricedArticle ? MoneyRenderer(pricedArticle.itemPrice.amount) : '-';
        } else {
            const pricedArticle = this._orderPrices.articles.find(pricedArticle => pricedArticle.articleCode.trim() === article.code.trim());
            const hasKnownItemPrice = pricedArticle && pricedArticle.itemPrice !== null && pricedArticle.itemPrice !== undefined;
            return hasKnownItemPrice ? MoneyRenderer(pricedArticle.itemPrice) : '-';
        }
    }

    amountOf(article) {
        const amount = article.amount;
        const unit = amount === 1 ? "Caja" : "Cajas";
        return `${amount} ${unit}`;
    }

    unitsPerAmountOf(article) {
        return article.itemsAmount
    }

    itemUnitAbbreviation(article){
        const unitMapping = {
            UNITS: "un.",
            KG: "kg."
        };
        return unitMapping[article.itemsUnit] || "";
    }

    subtotal() {
        return this._orderPrices.articlesTotalPrice
    }

    totalTaxes() {
        return this._orderPrices.totalVAT
    }

    totalGrossIncomeTaxes() {
        return this._orderPrices.totalGrossIncomeTaxes;
    }

    total(order) {
        return this._orderPrices.total
    }

    totalForArticle(article) {
        // FIXME: DUPLICADTED CODE WITH ORDERDETAILFEATURE. NEED TO MODEL THE ARTICLEPRICELIST
        if (this.orderIsInvoiced()) {
            const pricedArticle = this._order.articles.find(pricedArticle => pricedArticle.code.trim() === article.code.trim());
            return pricedArticle ? pricedArticle.price.amount : 0;
        } else {
            const pricedArticle = this._orderPrices.articles.find(pricedArticle => pricedArticle.articleCode.trim() === article.code.trim());
            return pricedArticle ? pricedArticle.totalPrice : 0
        }
    }


    repeatOrder() {
        console.log('REPEAT ORDER')
    }

    _getOrder() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => {
                this._order = response.order();
            },
            handlesError: async (response) => {
                if (response.orderWasDeleted?.()) {
                    await this._application.session().logOutAndRemoveOrder()
                    return errorToast("El pedido fue eliminado. Por favor, ingrese nuevamente y acceda a 'Mis Pedidos' para ver sus pedidos activos.")
                }
                errorToast("No se pudo cargar el detalle del pedido. Intente nuevamente.")
                this._navigator(ORDERS_HISTORY_PATH)
            }
        });
        return this._application.apiClient().orderDetail(this._orderId, responseHandler)
    }

    _getOrderPrices() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => {
                this._orderPrices = response.orderPrices();
            },
            handlesError: async (response) => {
                if (response.orderWasDeleted?.()) {
                    await this._application.session().logOutAndRemoveOrder()
                    return errorToast("El pedido fue eliminado. Por favor, ingrese nuevamente y acceda a 'Mis Pedidos' para ver sus pedidos activos.")
                }
            }
        });
        if (this.orderIsInvoiced()) {
            return this._application.apiClient().invoicePrices(this._order.invoiceNumber, responseHandler)
        }

        return this._application.apiClient().orderPrices(this._orderId, responseHandler)
    }
}